"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentSplitterBalanceDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const icons_material_1 = require("@mui/icons-material");
const react_query_1 = require("@tanstack/react-query");
const provider_user_1 = require("@dzambalaorg/provider-user");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const mui_dialog_confirmation_1 = require("@dzambalaorg/mui-dialog-confirmation");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const exchange_1 = require("@framework/exchange");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const release_json_1 = __importDefault(require("@framework/abis/json/Vesting/release.json"));
const provider_api_firebase_1 = require("@dzambalaorg/provider-api-firebase");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const PaymentSplitterBalanceDialog = (props) => {
    const { data, ...rest } = props;
    const { address, parameters } = data.contract;
    const { payees, shares } = parameters;
    const { profile } = (0, provider_user_1.useUser)();
    const { wallet } = profile;
    const currentShare = shares[payees.indexOf(wallet.toLowerCase())];
    const total = shares.reduce((partialSum, a) => partialSum + Number(a), 0);
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const api = (0, provider_api_firebase_1.useApi)();
    const { data: rows = [], isLoading } = (0, react_query_1.useQuery)({
        queryKey: [`/balances/${address}`],
        queryFn: async () => {
            return api.fetchJson({
                url: `/balances/${address}`,
                method: "GET",
            });
        },
    });
    const { execute: metaWithdraw } = (0, react_hooks_eth_1.useMetamask)(async (values) => {
        const tokenType = values.token.template.contract.contractType;
        const token = values.token.template.contract.address;
        if (tokenType === types_1.TokenType.NATIVE) {
            return writeContractAsync({
                address: address,
                abi: release_json_1.default,
                functionName: "release",
                args: [wallet],
            });
        }
        else if (tokenType === types_1.TokenType.ERC20) {
            return writeContractAsync({
                address: address,
                abi: release_json_1.default,
                functionName: "release",
                args: [token, wallet],
            });
        }
        else {
            throw new Error("unsupported token type");
        }
    });
    const handleRelease = (values) => {
        return async () => {
            await metaWithdraw(values);
        };
    };
    return ((0, jsx_runtime_1.jsxs)(mui_dialog_confirmation_1.ConfirmationDialog, { message: "dialogs.paymentSplitterBalances", "data-testid": "PaymentSplitterBalanceDialog", ...rest, children: [rows.length ? ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ui_kit_1.Typography, { variant: "body2", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "dialogs.paymentSplitterWallet", values: { wallet } }) }), (0, jsx_runtime_1.jsx)(ui_kit_1.Typography, { variant: "body2", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "dialogs.paymentSplitterShares", values: { currentShare, total } }) })] })) : null, (0, jsx_runtime_1.jsx)(mui_page_layout_1.ProgressOverlay, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(styled_1.StyledListWrapper, { count: rows.length, isLoading: isLoading, children: rows.map(balance => ((0, jsx_runtime_1.jsxs)(styled_1.StyledListItem, { children: [(0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { sx: { width: 0.6 }, children: balance.token.template.title }), (0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { children: (0, exchange_1.formatEther)(balance.amount, balance.token.template.contract.decimals, balance.token.template.contract.symbol) }), (0, jsx_runtime_1.jsx)(styled_1.ListActions, { children: (0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleRelease(balance), icon: icons_material_1.CurrencyExchange, message: "form.buttons.setAmount" }) })] }, balance.id))) }) })] }));
};
exports.PaymentSplitterBalanceDialog = PaymentSplitterBalanceDialog;
//# sourceMappingURL=index.js.map